import { createFileRoute } from "@tanstack/react-router";

import { ScreenSpinner } from "@/components";
import { useLabResults } from "@/domains/products/queries/use-lab-results";
import { Divider, Heading } from "@/ui";
import { CertificateOfAnalysisTable, ResearchDiagram, ResearchSections } from "./-components";

const ProductResearchAndTesting = () => {
  const { data: certificatesOfAnalysis } = useLabResults();

  if (!certificatesOfAnalysis) {
    return <ScreenSpinner />;
  }

  return (
    <div className="flex flex-col items-center px-6 py-4 text-content-secondary sm:py-20">
      <div className="flex w-full max-w-4xl flex-col gap-16">
        <div className="flex flex-col gap-8 sm:gap-9">
          <div>
            <Heading level={1}>What Goes Into Our Products?</Heading>

            <Divider.Line className="mt-8 mb-6" />

            <p className="sm:text-xl">
              At EO, every product starts with a simple mission: make it safe, effective, and easy
              to use. We design for real patient needs, test for safety and efficacy, evaluate
              quality-of-life impact, and check our work against the latest cannabis research.{" "}
            </p>
          </div>

          <ResearchDiagram />

          <ResearchSections />
        </div>

        <CertificateOfAnalysisTable certificatesOfAnalysis={certificatesOfAnalysis} />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_private/(with-footer)/product-research-and-testing/")({
  component: ProductResearchAndTesting,
});
